import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ColorPicker from '../../components/common/colorPicker';
import VersionBox from '../../components/common/VersionBox';
import PreviewColors from '../../components/preview/PreviewColors';
import constants from '../../constants';
import _actions from '../../actions';
import i18n from '../../i18n';
import LargeLoading from '../../components/svg/LargeLoading';

class Colors extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.saveCustomColors = this.saveCustomColors.bind(this);
        this.setDefaultLightTheme = this.setDefaultLightTheme.bind(this);
        this.setLightTheme = this.setLightTheme.bind(this);
        this.setDarkTheme = this.setDarkTheme.bind(this);
        this.resetDefaultTemplate = this.resetDefaultTemplate.bind(this);

        this.state = {
            isLoading: true,
            showPreview: true,
        };
    }

    componentDidMount() {
        this.props.actions.getTemplates();
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
    }

    componentDidUpdate(prevProps) {
        if (typeof prevProps.versions.select.id === 'undefined' || typeof prevProps.templates.data[0] === 'undefined') {
            if (this.props.versions.select.id && this.props.templates.data[0]) {
                this.props.actions.getTemplate(
                    this.props.templates,
                    this.props.versions.select.themeId,
                );
            }
        }

        if ((typeof prevProps.templates.select === 'undefined' || prevProps.templates.select === {}) || typeof prevProps.versions.select.id === 'undefined') {
            if (typeof this.props.templates.select !== 'undefined' && typeof this.props.versions.select.id !== 'undefined') {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ isLoading: false });
            }
        }
    }

    setDefaultLightTheme() {
        const template = this.props.templates.select;
        const version = this.props.versions.select;
        version.actionColor = template.lightColors.defaultActionColor;
        version.accentColor = template.lightColors.defaultAccentColor;
        version.primaryText = template.lightColors.defaultPrimaryTextColor;
        version.secondaryText = template.lightColors.defaultSecondaryTextColor;
        version.baseColorTheme = constants.ColorBaseTheme.find((n) => { return n.Name === 'Light'; }).Id;

        this.props.actions.updateProjectVersion(
            this.props.versions.select.projectId,
            version,
        );
    }

    setLightTheme() {
        const template = this.props.templates.select;
        const version = this.props.versions.select;
        version.baseColorTheme = constants.ColorBaseTheme.find((n) => { return n.Name === 'Light'; }).Id;
        if (version.actionColor.toUpperCase() === template.darkColors.defaultActionColor) {
            version.actionColor = template.lightColors.defaultActionColor;
            this.props.actions.updateProjectVersionbyParameter(
                this.props.versions.select.projectId,
                'actionColor',
                version.actionColor,
            );
        }
        if (version.accentColor.toUpperCase() === template.darkColors.defaultAccentColor) {
            version.accentColor = template.lightColors.defaultAccentColor;
            this.props.actions.updateProjectVersionbyParameter(
                this.props.versions.select.projectId,
                'accentColor',
                version.accentColor,
            );
        }
        if (version.primaryText.toUpperCase() === template.darkColors.defaultPrimaryTextColor) {
            version.primaryText = template.lightColors.defaultPrimaryTextColor;
            this.props.actions.updateProjectVersionbyParameter(
                this.props.versions.select.projectId,
                'primaryText',
                version.primaryText,
            );
        }
        if (version.secondaryText.toUpperCase() === template.darkColors.defaultSecondaryTextColor) {
            version.secondaryText = template.lightColors.defaultSecondaryTextColor;
            this.props.actions.updateProjectVersionbyParameter(
                this.props.versions.select.projectId,
                'secondaryText',
                version.secondaryText,
            );
        }
        this.props.actions.updateProjectVersionbyParameter(
            this.props.versions.select.projectId,
            'baseColorTheme',
            version.baseColorTheme,
        );
    }

    setDarkTheme() {
        const version = this.props.versions.select;
        const template = this.props.templates.select;
        version.baseColorTheme = constants.ColorBaseTheme.find((n) => { return n.Name === 'Dark'; }).Id;
        if (version.actionColor.toUpperCase() === template.lightColors.defaultActionColor) {
            version.actionColor = template.darkColors.defaultActionColor;
            this.props.actions.updateProjectVersionbyParameter(
                this.props.versions.select.projectId,
                'actionColor',
                version.actionColor,
            );
        }
        if (version.accentColor.toUpperCase() === template.lightColors.defaultAccentColor) {
            version.accentColor = template.darkColors.defaultAccentColor;
            this.props.actions.updateProjectVersionbyParameter(
                this.props.versions.select.projectId,
                'accentColor',
                version.accentColor,
            );
        }
        if (version.primaryText.toUpperCase() === template.lightColors.defaultPrimaryTextColor) {
            version.primaryText = template.darkColors.defaultPrimaryTextColor;
            this.props.actions.updateProjectVersionbyParameter(
                this.props.versions.select.projectId,
                'primaryText',
                version.primaryText,
            );
        }
        if (version.secondaryText.toUpperCase()
            === template.lightColors.defaultSecondaryTextColor) {
            version.secondaryText = template.darkColors.defaultSecondaryTextColor;
            this.props.actions.updateProjectVersionbyParameter(
                this.props.versions.select.projectId,
                'secondaryText',
                version.secondaryText,
            );
        }
        this.props.actions.updateProjectVersionbyParameter(
            this.props.versions.select.projectId,
            'baseColorTheme',
            version.baseColorTheme,
        );
    }

    resetDefaultTemplate(colorType) {
        const version = this.props.versions.select;
        const template = this.props.templates.select;

        if (typeof template === 'undefined' || !template.lightColors) {
            return '';
        }
        const colorSet = constants.ColorBaseTheme
            .find((n) => { return n.Id === version.baseColorTheme; }).Name;
        switch (colorSet) {
            case 'Dark':
                switch (colorType) {
                    case 'ACTION COLOR':
                        return template.darkColors.defaultActionColor;

                    case 'ACCENT COLOR':
                        return template.darkColors.defaultAccentColor;

                    case 'PRIMARY TEXT':
                        return template.darkColors.defaultPrimaryTextColor;

                    case 'SECONDARY TEXT':
                        return template.darkColors.defaultSecondaryTextColor;

                    default:
                        return '';
                }
            case 'Light':
                switch (colorType) {
                    case 'ACTION COLOR':
                        return template.lightColors.defaultActionColor;

                    case 'ACCENT COLOR':
                        return template.lightColors.defaultAccentColor;

                    case 'PRIMARY TEXT':
                        return template.lightColors.defaultPrimaryTextColor;

                    case 'SECONDARY TEXT':
                        return template.lightColors.defaultSecondaryTextColor;

                    default:
                        return '';
                }

            default:
                return '';
        }
    }

    saveCustomColors(picker, pickerValue) {
        const version = this.props.versions.select;
        let truncd = '';
        switch (picker) {
            case 1:
                version.actionColor = `${pickerValue}`;
                truncd = version.actionColor.substr(1, 6);
                this.props.actions.updateProjectVersionbyParameter(
                    this.props.versions.select.projectId,
                    'actionColor',
                    truncd,
                );

                break;
            case 2:
                version.accentColor = `${pickerValue}`;
                truncd = version.accentColor.substr(1, 6);
                this.props.actions.updateProjectVersionbyParameter(
                    this.props.versions.select.projectId,
                    'accentColor',
                    truncd,
                );

                break;
            case 3:
                version.primaryText = `${pickerValue}`;
                truncd = version.primaryText.substr(1, 6);
                this.props.actions.updateProjectVersionbyParameter(
                    this.props.versions.select.projectId,
                    'primaryText',
                    truncd,
                );

                break;
            case 4:
                version.secondaryText = `${pickerValue}`;
                truncd = version.secondaryText.substr(1, 6);
                this.props.actions.updateProjectVersionbyParameter(
                    this.props.versions.select.projectId,
                    'secondaryText',
                    truncd,
                );

                break;
            default: return 0;
        }
        return 0;
    }

    render() {
        const version = this.props.versions.select;
        const previewColors = (<PreviewColors version={version} />);
        let color;
        let color2;
        let theme;
        if (!this.state.isLoading) {
            color = (
                <div className="design-setting-list">
                    <ColorPicker
                        saveCustomColors={this.saveCustomColors}
                        name={i18n.t('colors.label3')}
                        reset={this.resetDefaultTemplate('ACTION COLOR')}
                        csIndex={1}
                        hex={version.actionColor}
                        containerId="action-color__picker"
                    />

                    <ColorPicker
                        saveCustomColors={this.saveCustomColors}
                        name={i18n.t('colors.label4')}
                        reset={this.resetDefaultTemplate('ACCENT COLOR')}
                        csIndex={2}
                        hex={version.accentColor}
                        containerId="accent-color___picker"
                    />
                </div>
            );
            color2 = (
                <div className="design-setting-list">
                    <ColorPicker containerId="primary-text__picker" saveCustomColors={this.saveCustomColors} name={i18n.t('colors.label5')} reset={this.resetDefaultTemplate('PRIMARY TEXT')} csIndex={3} hex={version.primaryText} />

                    <ColorPicker containerId="secondary-text__picker" saveCustomColors={this.saveCustomColors} name={i18n.t('colors.label6')} reset={this.resetDefaultTemplate('SECONDARY TEXT')} csIndex={4} hex={version.secondaryText} />
                </div>
            );
            theme = (
                <div data-qa="theme-setting" id="theme-setting" className="design-setting">
                    <h3 data-qa="theme-setting-header" id="theme-setting-header">{i18n.t('colors.theme')}</h3>
                    <div className="inline-radio">
                        <div className="radio">
                            <input data-qa="set-light-theme" id="set-light-theme" type="radio" name="base-theme" onClick={() => { return this.setLightTheme(); }} defaultChecked={version.baseColorTheme === constants.ColorBaseTheme.find((n) => { return n.Name === 'Light'; }).Id} tabIndex="0" className="hidden" />
                            <label data-qa="set-light-theme__label" id="set-light-theme__label">{i18n.t('colors.label1')}</label>
                        </div>
                        <div className="radio">
                            <input data-qa="set-dark-theme" id="set-dark-theme" type="radio" name="base-theme" onClick={() => { return this.setDarkTheme(); }} defaultChecked={version.baseColorTheme === constants.ColorBaseTheme.find((n) => { return n.Name === 'Dark'; }).Id} tabIndex="0" className="hidden" />
                            <label data-qa="set-dark-theme__label" id="set-dark-theme__label">{i18n.t('colors.label2')}</label>
                        </div>
                    </div>
                </div>
            );
        } else {
            theme = (<div id="loading-page"><div id="loading-container_loader"><LargeLoading /></div></div>);
            color = (<div />);
            color2 = (<div />);
        }
        const form = (
            <div data-qa="colors-page-form" id="colors-page-form" className="form-wrapper">
                <h1 data-qa="colors-header" id="colors-header">{i18n.t('colors.header')}</h1>
                <p data-qa="colors-subhead" id="colors-subhead" className="lead">{i18n.t('colors.subtitle')}</p>

                <div data-qa="theme-options" id="theme-options" className="general-section theme-options">
                    <h2 className="section-name">{i18n.t('colors.section1')}</h2>
                    <div className="design-setting-list">
                        {theme}
                    </div>
                </div>

                <div id="color-scheme-options" className="general-section color-scheme-options">
                    <h2 className="section-name">{i18n.t('colors.section2')}</h2>
                    {color}
                </div>

                <div id="text-color-options" className="general-section text-color-options">
                    <h2 className="section-name">{i18n.t('colors.section3')}</h2>
                    {color2}
                </div>
            </div>
        );

        return (
            <VersionBox
                name={this.props.versions.select.name}
                versionNumber={this.props.versions.select.version}
                saving={this.props.versions.inProgress}
                justSaved={this.props.projects.justSaved}
                menuSection="Design"
                menuItem="Colors"
                previewCssClass="design_colors"
                previewChild={previewColors}
                configCode={this.props.versions.select.configCode}
                showPreview={this.state.showPreview}
                x
            >
                <div id="design-page" className="content-inside">
                    {form}
                </div>
            </VersionBox>

        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        versions: state.versions,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Colors);
